import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useWishlist } from '../../context/WishlistContext';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const { isInWishlist, toggleWishlist } = useWishlist();
  const [isHovered, setIsHovered] = useState(false);

  const isFavorited = isInWishlist(product.id);
  const isSoldOut = product.stock <= 0;

  const handleWishlistClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(product);
  };

  // Determine which image to show
  const primaryImage = product.images && product.images[0];
  const secondaryImage = product.images && product.images.length > 1 ? product.images[1] : primaryImage;
  const currentImage = isHovered && secondaryImage ? secondaryImage : primaryImage;

  // Format currency
  const formatPrice = (amount) => `₹${amount?.toLocaleString('en-IN')}`;

  return (
    <div
      className={`product-card ${isSoldOut ? 'is-sold-out' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={`/products/${product.slug}`} className="product-card-link">
        {/* Image Container */}
        <div className="product-image-wrap">
          <img
            src={currentImage}
            alt={product.name}
            className="product-card-img"
            loading="lazy"
          />

          {/* Badges */}
          <div className="product-badges">
            {isSoldOut ? (
              <span className="badge badge-soldout">Sold Out</span>
            ) : (
              <>
                {product.isBestseller && <span className="badge badge-bestseller">Bestseller</span>}
                {product.isNewArrival && !product.isBestseller && <span className="badge badge-new">New</span>}
                {product.isFestive && <span className="badge badge-festive">Festive</span>}
              </>
            )}
          </div>

          {/* Wishlist Button */}
          <button
            type="button"
            className={`wishlist-toggle-btn ${isFavorited ? 'active' : ''}`}
            onClick={handleWishlistClick}
            aria-label={isFavorited ? "Remove from wishlist" : "Add to wishlist"}
          >
            <Heart
              size={18}
              fill={isFavorited ? "var(--color-primary)" : "none"}
              color={isFavorited ? "var(--color-primary)" : "var(--color-text)"}
            />
          </button>
        </div>

        {/* Card Details */}
        <div className="product-card-details">
          {/* Fabric / Subtitle */}
          <span className="product-card-category">{product.category} • {product.fabric?.split(',')[0]}</span>

          {/* Title */}
          <h3 className="product-card-title">{product.name}</h3>

          {/* Colour Swatches */}
          {product.colours && product.colours.length > 0 && (
            <div className="product-card-colors" aria-label="Available colours">
              {product.colours.map((col, idx) => (
                <span
                  key={idx}
                  className="color-dot"
                  style={{ backgroundColor: col.hex }}
                  title={col.name}
                />
              ))}
              <span className="color-count-label">{product.colours.length} {product.colours.length === 1 ? 'colour' : 'colours'}</span>
            </div>
          )}

          {/* Price Block */}
          <div className="product-price-block">
            <span className="price-current">{formatPrice(product.price)}</span>
            {product.compareAtPrice && product.compareAtPrice > product.price && (
              <>
                <span className="price-original">{formatPrice(product.compareAtPrice)}</span>
                <span className="price-discount">({product.discountPercent}% OFF)</span>
              </>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductCard;

